import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import cookie from 'react-cookie';
import Linkify from 'react-linkify';

import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Toolbar from '@material-ui/core/Toolbar';

import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import AnnounceIcon from '@material-ui/icons/Announcement';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import CloseIcon from '@material-ui/icons/Close';
import ExitIcon from '@material-ui/icons/ExitToApp';
import { isEmpty, decodeSessionToken, hashString, getUserRoleFromJWT } from '../../helpers';
import { getOnboardingState } from '../../utils/onboardingmanager';
import { clearAllRetryTimers } from '../../utils/retrytimer';
import { toggleHelptips, hideAnnouncement } from '../../utils/toggleuseroptions';
import DeviceNotifications from './devicenotifications';
import DeploymentNotifications from './deploymentnotifications';
import AppActions from '../../actions/app-actions';
import AppStore from '../../stores/app-store';

import { logout } from '../../auth';

const timeOut = 10 * 1000;

export default class Header extends React.Component {
  static contextTypes = {
    router: PropTypes.object,
    location: PropTypes.object
  };

  constructor(props, context) {
    super(props, context);
    this.state = this._getInitialState();
    /** Bind methods to avoid re-creation */
    this._onChangeBind = this._onChange.bind(this);
  }
  UNSAFE_componentWillMount() {
    AppStore.changeListener(this._onChangeBind);
  }
  componentWillUnmount() {
    AppStore.removeChangeListener(this._onChangeBind);
    this._triggerRefreshTimer(false);
    this._isMounted = false;
  }
  componentDidUpdate(prevProps, prevState) {
    if (!this.state.sessionId || isEmpty(this.state.user) || this.state.user === null) {
      this._updateUsername();
    } else {
      if (prevState.sessionId && prevState.sessionId !== this.state.sessionId) {
        this._hasDeployments();
        this._hasArtifacts();
        this._checkShowHelp();
        this._checkHeaderInfo();
        this._getGlobalSettings();
      }
    }
  }
  componentDidMount() {
    this._isMounted = true;
    // check logged in user
    if (this.props.isLoggedIn) {
      this._updateUsername();
      this._hasDeployments();
      this._checkHeaderInfo();
      this._hasArtifacts();
      this._checkShowHelp();
      this._getGlobalSettings();
      this._triggerRefreshTimer(true);
    }
  }
  _getInitialState() {
    return {
      sessionId: cookie.load('JWT'),
      currentUserRole: getUserRoleFromJWT(),
      user: AppStore.getCurrentUser(),
      showHelptips: AppStore.showHelptips(),
      pendingDevices: AppStore.getTotalPendingDevices(),
      acceptedDevices: AppStore.getTotalAcceptedDevices(),
      artifacts: AppStore.getArtifactsRepo(),
      hasDeployments: AppStore.getHasDeployments(),
      multitenancy: AppStore.hasMultitenancy(),
      deviceLimit: AppStore.getDeviceLimit(),
      inProgress: AppStore.getNumberInProgress(),
      globalSettings: AppStore.getGlobalSettings(),
      org: AppStore.getOrganization()
    };
  }
  _onChange() {
    this.setState(this._getInitialState());
  }

  _triggerRefreshTimer(trigger) {
    if (trigger && !this._timerId && this._isMounted) {
      this._timerId = setInterval(() => {
        if (this._isMounted) {
          this._checkHeaderInfo();
        }
      }, timeOut);
    } else if(!trigger && this._timerId) {
      clearInterval(this._timerId);
      this._timerId = null;
    }
  }

  _checkHeaderInfo() {
    this._getDeviceLimit();
    this._deploymentsInProgress();
    this._hasDevices();
    this._hasPendingDevices();
    this._checkAnnouncement();
  }
  _getGlobalSettings() {
    return AppActions.getGlobalSettings()
      .then(settings => {
        return AppActions.saveGlobalSettings(settings);
      })
      .catch(err => console.log('error', err));
  }
  _getDeviceLimit() {
    var self = this;
    return AppActions.getDeviceLimit().then(limit => self.setState({ deviceLimit: limit }));
  }
  _checkShowHelp() {
    //checks if user id is set and if cookie for helptips exists for that user
    var userCookie = (this.state.user !== null && this.state.user.id) ? cookie.load(this.state.user.id) : undefined;
    // if no user cookie set, do so via togglehelptips
    if (typeof userCookie === 'undefined' || typeof userCookie.help === 'undefined') {
      toggleHelptips();
    } else {
      // got user cookie but help value not set
      AppActions.setShowHelptips(userCookie.help);
    }
  }
  _checkAnnouncement() {
    var hash = this.props.announcement ? hashString(this.props.announcement) : null;
    var announceCookie = (this.state.user !== null && this.state.user.id) ? cookie.load(this.state.user.id + hash) : undefined;
    if (hash && typeof announceCookie === 'undefined') {
      this.setState({ showAnnouncement: true, hash: hash });
    } else {
      this.setState({ showAnnouncement: false });
    }
  }
  _hideAnnouncement() {
    hideAnnouncement(this.state.hash);
    this.setState({ showAnnouncement: false });
  }
  _hasDeployments() {
    // check if *any* deployment exists, for onboarding help tips
    var self = this;
    return AppActions.getDeployments(1, 1)
      .then(deployments => self.setState({ hasDeployments: deployments.length }))
      .catch(err => console.log(err));
  }
  _deploymentsInProgress() {
    // check if deployments in progress
    var self = this;
    AppActions.getDeploymentCount('inprogress').then(inProgress => self.setState({ inProgress }));
  }

  _hasDevices() {
    // check if any devices connected + accepted
    var self = this;
    return AppActions.getDeviceCount('accepted')
      .then(acceptedDevices => self.setState({ acceptedDevices }))
      .catch(err => console.log(err));
  }
  _hasPendingDevices() {
    // check if any devices connected + accepted
    var self = this;
    return AppActions.getDeviceCount('pending')
      .then(pendingDevices => self.setState({ pendingDevices }))
      .catch(err => console.log(err.error));
  }
  _hasArtifacts() {
    var self = this;
    AppActions.getArtifacts();
    return self.state.artifacts.length;
  }
  _updateUsername() {
    var self = this;
    // get current user
    if (!self.state.gettingUser) {
      var userId = self.state.sessionId ? decodeSessionToken(self.state.sessionId) : decodeSessionToken(cookie.load('JWT'));
      if (!userId) {
        return;
      }
      self.setState({ gettingUser: true });
      return AppActions.getUser(userId)
        .then(user => {
          AppActions.setCurrentUser(user);
          self.setState({ user: user, gettingUser: false, org: AppStore.getOrganization() });
          self._checkShowHelp();
          self._getGlobalSettings();
          self._checkHeaderInfo();
        })
        .then(() => getOnboardingState(userId))
        .catch(err => {
          self.setState({ gettingUser: false });
          var errMsg = err.res.error;
          console.log(errMsg);
        });
    }
  }

  changeTab() {
    this._getGlobalSettings();
    this._checkHeaderInfo();
    AppActions.setSnackbar('');
  }
  handleClick = event => {
    this.setState({ anchorEl: event.currentTarget });
  };
  handleClose = () => {
    this.setState({ anchorEl: null });
  };
  onLogoutClick() {
    this.setState({ gettingUser: false });
    clearAllRetryTimers();
    // cookie.remove('JWT');
    // cookie.remove('role');
    logout();
    // this.context.router.history.push('/login');
  }
  render() {
    const self = this;
    const { anchorEl, user } = self.state;

    const menuButtonColor = '#c7c7c7';

    let userManageMenuItem = null;
    if (this.state.currentUserRole === 'systemadm') {
      userManageMenuItem = (
        <MenuItem component={Link} to="/settings/systemadmin-management">
          System Admin management
        </MenuItem>
      );
    } else if (this.state.currentUserRole === 'admin') {
      userManageMenuItem = (
        <MenuItem component={Link} to="/settings/user-management">
          User management
        </MenuItem>
      );
    }

    var dropDownElement = (
      <div style={{ marginRight: '0', paddingLeft: '20px' }}>
        <Button className="header-dropdown" style={{ fontSize: '14px', fill: 'rgb(0, 0, 0)', textTransform: 'none' }} onClick={self.handleClick}>
          <AccountCircleIcon style={{ marginRight: '8px', top: '5px', fontSize: '20px', color: menuButtonColor }} />
          {(user || {}).email}
          {anchorEl ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
        </Button>
        <Menu
          anchorEl={anchorEl}
          onClose={self.handleClose}
          open={Boolean(anchorEl)}
          anchorOrigin={{
            vertical: 'center',
            horizontal: 'center'
          }}
          transformOrigin={{
            vertical: 'bottom',
            horizontal: 'center'
          }}
          onClick={self.handleClose}
        >
          <MenuItem component={Link} to="/settings">
            Settings
          </MenuItem>
          <MenuItem component={Link} to="/settings/my-account">
            My account
          </MenuItem>
          {this.state.multitenancy && this.state.currentUserRole !== 'systemadm' ? (
            <MenuItem component={Link} to="/settings/my-organization">
              My organization
            </MenuItem>
          ) : null}
          {userManageMenuItem}
          {this.state.showHelptips ? (
            <MenuItem onClick={toggleHelptips}>{this.state.showHelptips ? 'Hide help tooltips' : 'Show help tooltips'}</MenuItem>
          ) : null }
          {this.state.showHelptips ? (
            <MenuItem component={Link} to="/help/getting-started">
              Help
            </MenuItem>
          ) : null}
          <MenuItem onClick={() => self.onLogoutClick()}>
            <ListItemText primary="Log out" />
            <ListItemSecondaryAction>
              <IconButton>
                <ExitIcon style={{ color: menuButtonColor, fill: menuButtonColor }} />
              </IconButton>
            </ListItemSecondaryAction>
          </MenuItem>
        </Menu>
      </div>
    );

    const toolbarStyle = { height: '56px', minHeight: 'unset', paddingLeft: '16px', paddingRight: '16px' };
    const docServerLink = 'http://ewm-docs.edgeway.io';
    let currentUser = this.state.currentUserRole || '';
    let headerHidden = null;

    if (self.context.location.pathname === '/login' ||
        self.context.location.pathname === '/signup' ||
        self.context.location.pathname === '/password') {
      headerHidden = 'hidden';
    }

    if (currentUser === 'systemadm') {
      currentUser = 'systemadmin';
    }
    const tenantAndRole = `${currentUser} | ${this.state.org.name || ''}`;

    return (
      <div id="fixedHeader" className={`${self.props.className} ${headerHidden}`}>
        <Toolbar style={Object.assign({ backgroundColor: '#fff' }, toolbarStyle)}>
          <Toolbar key={0} style={toolbarStyle}>
            {/* <Link to="/" id="logo-picto" /> */}
            <Link to="/">
              <img src="assets/img/1-edgeway_logo_rgb.png" alt="" style={{width: 150, height: 56}} />
            </Link>
            <div id="titleBox" style={{ fontSize: '1em', fontWeight: 'bold', width: '50em', textAlign: 'right'}}>
              <h1> EdgeWay Management Portal </h1>
            </div>
          </Toolbar>

          <Toolbar key={1} style={{ flexGrow: '2' }}>
            {this.props.announcement ? (
              <div id="announcement" className={this.state.showAnnouncement ? 'fadeInSlow' : 'fadeOutSlow'} style={{ display: 'flex', alignItems: 'center' }}>
                <AnnounceIcon className="red" style={{ marginRight: '4px', height: '18px', minWidth: '24px' }} />
                <Linkify properties={{ target: '_blank' }}>{this.props.announcement}</Linkify>
                <CloseIcon style={{ marginLeft: '4px', height: '16px', verticalAlign: 'bottom' }} onClick={() => this._hideAnnouncement()} />
              </div>
            ) : null}
          </Toolbar>

          <Toolbar key={2} style={{ flexShrink: '0' }}>
            <div>
              <p><a href={docServerLink} target="_blank">Help</a></p>
            </div>
          </Toolbar>

          <Toolbar key={3} style={{ flexShrink: '0' }}>
            <DeviceNotifications pending={this.state.pendingDevices} total={this.state.acceptedDevices} limit={this.state.deviceLimit} />
            <DeploymentNotifications inprogress={this.state.inProgress} />
            <Toolbar key={4} style={toolbarStyle}>
              <div id="titleBox" style={{ fontSize: '.5em', fontWeight: 'bold', textAlign: 'center'}}>
                <h1>{tenantAndRole.toUpperCase()}</h1>
              </div>
            </Toolbar>
            {dropDownElement}
          </Toolbar>
        </Toolbar>

        <div id="header-nav" />
      </div>
    );
  }
}
